export function pluralize(
  count: number,
  single: string,
  plural: string,
  missing = "inga",
  singleCountWord = "en"
) {
  if (count === 0) {
    return `${missing} ${plural}`;
  }
  if (count === 1) {
    return `${singleCountWord} ${single}`;
  }

  return `${count} ${plural}`;
}

export function pluralizeNewMessages(count: number) {
  if (count === 0) {
    return "";
  }
  return pluralize(count, "nytt", "nya", "", "ett");
}

export function pluralizeNewDeliveries(count: number) {
  if (count === 0) {
    return "";
  }
  return pluralize(count, "ny", "nya", "", "en");
}

export function pluralizeCustomer(count: number) {
  return pluralize(count, "kund", "kunder", "inga");
}
